import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, RouterLinkActive } from '@angular/router';
import { Constants } from 'src/app/constants';
import { ExportStateService } from 'src/app/service/export-state.service';

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    standalone: false
})
export class ToolbarComponent implements OnInit {

  @ViewChild('home') private home: RouterLinkActive; // NOSONAR
  enableHomeGrey = false;
  enableHomeRed = true;
  activeBoard: boolean = false;
  highlightASN = false;
  highlightDocumentControl = false;
  highlightLOGS = false;
  isAccessible = false;
  constructor(private readonly router: Router, private  readonly state: ExportStateService, private readonly constants: Constants) { }

  ngOnInit(): void {
    this.state.roleState.subscribe(data => {
      if (data) {
        const userRoles = JSON.parse(data);
        if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_NAMCPlanner60EXP)) {
          this.isAccessible = true;
        }
      }
    })
  }
  ngAfterContentChecked(): void {
    this.makeAllFalse();
    if (this.router.url == "/" || this.router.url == '/home') {  // NOSONAR
      this.enableHomeRed = true;
      this.enableHomeGrey = false;
      this.activeBoard = true;
    }
    else if (this.router.url == '/summary' || this.router.url == '/history' || this.router.url == '/pallet-type' || this.router.url == '/summary/summary-details') {  // NOSONAR
      this.highlightASN = true
    } else if (this.router.url == '/shipments' || this.router.url == '/invoices' || this.router.url == '/transportation-entry' || this.router.url == '/transportation-entry/transportation-entry-details' || this.router.url == '/shipments/shipment-details' ) {  // NOSONAR
      this.highlightDocumentControl = true;
    }else if (this.router.url == '/logs'){   // NOSONAR
      this.highlightLOGS = true;
    }
  }

  makeAllFalse() {
    this.activeBoard = false;
    this.enableHomeRed = false;
    this.enableHomeGrey = true;
    this.highlightASN = false;
    this.highlightDocumentControl = false;
    this.highlightLOGS=false;
  }

}
